export default __webpack_public_path__ + "static/media/logo-spotify.3f055cde.svg";